document.addEventListener("DOMContentLoaded", function () {
    let blockedKeyword = "House Number 43";

    function isBlockedAddress() {
        let shippingAddress = document.querySelector("#checkout_shipping_address_address1")?.value || "";
        return shippingAddress.includes(blockedKeyword);
    }

    function blockAction(event, message) {
        if (isBlockedAddress()) {
            alert(message);
            event.preventDefault();
            return false;
        }
    }

    // **💡 Block Adding to Cart (Handles Both Click & AJAX)**
    document.body.addEventListener("click", function (event) {
        let target = event.target.closest("button, input[type='submit']");
        if (target && target.getAttribute("name") === "add") {
            blockAction(event, "Your shipping address is restricted. You cannot add items to the cart.");
        }
    });

    // **💡 Block Checkout (Avenue Theme Specific)**
    document.querySelectorAll("#checkout, .cart__checkout-button").forEach(button => {
        button.addEventListener("click", function (event) {
            blockAction(event, "Your shipping address is restricted. You cannot proceed to checkout.");
        });
    });

    // **💡 Block Registration (Prevents Account Creation)**
    document.querySelector("form[action='/account']")?.addEventListener("submit", function (event) {
        let registerAddress = document.querySelector("input[name='address1']")?.value || "";
        if (registerAddress.includes(blockedKeyword)) {
            blockAction(event, "Your address is restricted. You cannot create an account.");
        }
    });

    // **💡 Watch for Address Changes in Checkout**
    let checkoutFields = ["#checkout_shipping_address_address1", "#checkout_shipping_address_city"];
    checkoutFields.forEach(selector => {
        let field = document.querySelector(selector);
        if (field) {
            field.addEventListener("input", function () {
                if (isBlockedAddress()) {
                    alert("Your shipping address is restricted. Please use a different address.");
                }
            });
        }
    });

    const feature = document.querySelectorAll('.product-grid-product-template .clearfix ul li');
   feature.forEach((list) => {
  const boldTag = list.getElementsByTagName('b')[0] ||  list.getElementsByTagName('strong')[0];
  if(boldTag.innerHTML.includes("Color:"))
  {
    list.style.display = "none";
  }
});

});


